module.exports = __webpack_public_path__ + "img/CM-SS-25-Mitsubishi-Lifestyle.b4ec0a1d.jpg";